import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Editor as H1Editor } from "./Editor";
import { H1 } from "./H1Block";
import { defaultData } from "./H1BlockDefaultData";
import { meta } from "./H1BlockMetaData";

export const H1Block: BlockExport = {
  type: "component",
  Block: H1,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  Editor: H1Editor,
  defaultData,
  meta,
};
